export { default as PersonalDataScreen } from './PersonalDataScreen'
export { default as AnamneseScreen } from './AnamneseScreen'
export { default as CategoryScreen } from './CategoryScreen'
export { default as CompanyPatientScreen } from './CompanyPatientScreen'
export { default as LoginScreen } from './LoginScreen'
export { default as ConfirmationScreen } from './ConfirmationScreen'
export { default as SeeMedicalHistory } from './SeeMedicalHistory'
export { default as DiagnosticFewDetailsScreen } from './DiagnosticFewDetailsScreen'
